import { useState,useEffect,useRef  } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, billingServiceValidation } from "./billing-order-schema";
import { createBillingService,getCustCategorySetting,useCustCriteriaOptionsQuery,uploadAttachment } from "services/data.billing.service";
import BillingServiceInfo from "./components/BillingOrderInfo";
import { useQuery } from "@tanstack/react-query";
import { useCustomerValue } from "providers/CustomerContext";
//import { useCustCategoryOptionsQuery } from "hooks/useQueryHook";
import MDButton from "components/MDButton";

function AddBillingService() {
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
const { customerCode } = useCustomerValue();
  const [categoryOptions, setcategoryOptions] = useState([]);
  const [criteriaOptions, setcriteriaOptions] = useState([]);
//const [customerCode, setCustomerCode] = useState("");

//   const useCustCategoryOptionsQuery = ({ customerCode, enabled, ...query }) => {
//   let isEnabled = enabled;
//   if (isEnabled === undefined) {
//     isEnabled = Boolean(customerCode);
//   }
//   return useQuery({
//     queryKey: ["cust-category-options", { customerCode }],
//     queryFn: () => getCustCategorySetting({ customerCode }),
//     enabled: !!customerCode,
//     ...query,
//   });
// };

//  const useCustCriteriaOptionsQuery = ({ customerCode,category, enabled, ...query }) => {
//    let isEnabled = enabled;
//    if (isEnabled === undefined) {
//      isEnabled = Boolean(customerCode);
//    }
//    return useQuery({
//      queryKey: ["cust-criteria-options", { customerCode,category }],
//      queryFn: () => getCustCategorySetting({ customerCode,category }),
//      enabled: isEnabled,
//      ...query,
//    });
//  }
//    useCustCategoryOptionsQuery({customerCode,onSuccess: (data) => {
//    setcategoryOptions(data.data.data);
//  }});


const { isLoading, error } = useQuery(
  ["cust-category-options", customerCode],
  () => getCustCategorySetting({ customerCode }),
  {
    enabled: !!customerCode, // only run if customerCode exists
    onSuccess: (data) => {
      setcategoryOptions(data.data.data); // update dropdown
    },
  }
);



  // useCustCriteriaOptionsQuery({
  //   category: categoryOptions,
  //   //whCode: warehouseCode, //need change to category later
  //   onSuccess: (data) => setcriteriaOptions(data.data.data),
  // });

  const createBillingServiceMutation = useMutation(createBillingService, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });

  const form = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(billingServiceValidation),
  });

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
    setValue,
    reset,
  } = form;

  const selectedCategory = watch("category");
useEffect(() => {
  console.log("Selected category:", selectedCategory);
}, [selectedCategory]);

// const { data: criteriaData } = useCustCriteriaOptionsQuery({
//   customerCode,
//   category: selectedCategory,
//   enabled:   typeof customerCode === "string" &&
//   customerCode.length > 0 &&
//   typeof selectedCategory === "string" &&
//   selectedCategory.length > 0,
//   onSuccess: (data) => {
//     // update your dropdown list
//     console.log("Query ran! Returned data:", data);
//     console.log("data.data (the array):", data.data);
//     console.log(data.data);
//     console.log(data.data.data);
//     setcriteriaOptions(data.data); // or data.data depending on your API
//   },
// });

const {
    data: criteriaData,
    refetch: refetchCriteria,
  } = useQuery(
    ["cust-criteria-options", customerCode, selectedCategory],
    () => useCustCriteriaOptionsQuery({ customerCode, category: selectedCategory }),
    {
      enabled: false, // disable auto-fetch
      onSuccess: (data) => {
        console.log("Criteria query success for", selectedCategory, data);
        console.log(data.data);
        console.log(data.data.data);
        setcriteriaOptions(data.data.data); // update state
      },
    }
  );

   useEffect(() => {
    if (selectedCategory) {
      console.log("Refetching criteria for:", selectedCategory);
      refetchCriteria();
    }
  }, [selectedCategory, refetchCriteria]);

//const criteriaOptions = criteriaData?.data ?? [];

  const infoProps = {
    customerCode,
    categoryOptions,
    criteriaOptions,
    control,
    errors,
    setValue,
    formRender,
  };
  // const onSubmit = (data) => {
  //   createBillingServiceMutation.mutate(data, {
  //     onSuccess: () => {
  //       reset();
  //     },
  //   });
  // };
  const [file, setFile] = useState(null);
  const [uploadedFileName, setUploadedFileName] = useState(null);
  const handleFileChange = (e) => {
  const selectedFile = e.target.files[0];
  if (!selectedFile) return;

  // Optional validation
  const allowedTypes = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
    "image/png",
    "image/jpeg",
    "image/jpg",
  ];

  if (!allowedTypes.includes(selectedFile.type)) {
    alert("Only PDF, Excel, or Image files are allowed.");
    return;
  }

  setFile(selectedFile);
};
  const fileInputRef = useRef(null);
  const uploadAttachmentMutation = useMutation(uploadAttachment);
  const onUploadAttachment = () => {
  // OPTIONAL → allow empty
  if (!file) {
    console.log("No file selected, skipping upload...");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);
  //formData.append("customerCode", customerCode); // optional extra data
 uploadAttachmentMutation.mutate(
    { formData, customerCode },
    {
      onSuccess: (data) => {
        console.log("Upload success:", data);
        setAlert(<Success data={data} onChange={setAlert} />);
        setUploadedFileName(data.data.fileName);
        setFile(null);
      },
      onError: (data) => {
        console.error("Upload failed:", data);
      },
    }
  );
  // uploadAttachmentMutation.mutate(formData, {
  //   onSuccess: (res) => {
  //     console.log("Upload success:", res);
  //     setFile(null);
  //   },
  //   onError: (err) => {
  //     console.error("Upload failed:", err);
  //   },
  // });
};

const handleCancelFile = () => {
  setFile(null);

  // also reset input value (IMPORTANT)
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};

  const onSubmit = (data) => {
  createBillingServiceMutation.mutate(
    {
      ...data,
      customerCode,
      attachmentFileName: uploadedFileName,
    },
    {
      onSuccess: () => {
        reset();
        setUploadedFileName(null);
      },
    }
  );
};

  const createStatus = createBillingServiceMutation.status === "loading";
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <BillingServiceInfo {...infoProps} />
        {/* <CustomerLogo type="CompanyLogo"/> */}
        {/* <input
  type="file"
  accept=".pdf,.xlsx,.xls,image/*"
  onChange={(e) => handleFileChange(e)}
/> */}
<div>
<input
  type="file"
  accept=".pdf,.xlsx,.xls,image/*"
  ref={fileInputRef}
  style={{ display: "none" }}
  onChange={handleFileChange}
/>
<MDButton
  variant="gradient"
  color="info"
  type="button"
  onClick={() => fileInputRef.current.click()}
>
  Choose File
</MDButton>
{file && (
  <div style={{ marginTop: "8px" }}>
    Selected: {file.name}
    <MDButton
      variant="outlined"
      color="info"
      sx={{ marginLeft: "1.5rem" }}
      onClick={handleCancelFile}
    >
      Remove
    </MDButton>
  </div>
)}
</div>
<div style={{ marginTop: "8px" }}>
        <MDButton variant="gradient" color="info"   type="button" onClick={onUploadAttachment}>
  Upload Attachment
</MDButton>
</div>
        <SubmitButton label="submit" disabled={createStatus}  url="/billing/billing-service" />
      </form>
    </Layout>
  );
}

export default AddBillingService;
